import { render, staticRenderFns } from "./changeSetting.vue?vue&type=template&id=505732b0&"
import script from "./changeSetting.vue?vue&type=script&lang=js&"
export * from "./changeSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports